import React from "react";
import ForgotPassword from "./ForgotPassword";
import OTPModal from "./OTPModal";
import ResetPassword from "./ResetPassword";

const AuthModals = ({
    openForgot,
    setOpenForgot,
    otpOpen,
    openOTP,
    resetOpen,
    openReset,
    email,
    setEmail,

}) => {

    return (
        <>
            {/* Forgot Password Modal */}
            {openForgot && (
                <ForgotPassword
                    visible={openForgot}
                    setVisible={setOpenForgot}
                    openOTP={() => openOTP(true)}
                    setEmail={setEmail}
                />
            )}

            {/* OTP Modal */}
            {otpOpen && (
                <OTPModal
                    otpModal={otpOpen}
                    setOtpModal={openOTP}
                    openReset={() => openReset(true)}
                    email={email}
                />
            )}

            {/* Reset Password Modal */}
            {resetOpen && (
                <ResetPassword
                    resetModal={resetOpen}
                    setResetModal={openReset}
                    email={email}
                    handleCancelReset={() => openReset(true)}
                />
            )}
        </>
    );
};

export default AuthModals;